import React, { useState } from 'react';
import './HeroSection.css';
import logo from '../Images/myapoti_logo_pot.png';

const HeroSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // { type: 'success' | 'error', message: string }
  const [isLoading, setIsLoading] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // ✅ use env variable

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus(null);

    try {
      const response = await fetch(`${API_BASE_URL}/users/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        // try to read JSON, fallback to text if response isn't valid JSON
        let errorMessage = 'Subscription failed';
        try {
          const errorData = await response.json();
          errorMessage = errorData?.detail || errorMessage;
        } catch {
          const text = await response.text();
          if (text) errorMessage = text;
        }
        throw new Error(errorMessage);
      }

      setStatus({ type: 'success', message: '✅ Thank you! You’ll be notified.' });
      setEmail('');
    } catch (error) {
      setStatus({ type: 'error', message: error.message || 'Something went wrong.' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h1>Welcome to MyApoti</h1>
          <p>
            Find verified pharmacies and check drug availability in real time,
            anywhere near you. Coming soon on mobile!
          </p>
          <form className="cta-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Enter your email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Submitting...' : 'Notify Me'}
            </button>
          </form>

          {status && (
            <p className={status.type === 'success' ? 'success-message' : 'error-message'}>
              {status.message}
            </p>
          )}
        </div>

        <div className="hero-image">
          <img src={logo} alt="App coming soon" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
